<script lang="ts">
  export let size: "standard" | "fit-content" = "fit-content";
</script>

<div
  class="m-2 space-y-1 overflow-y-auto overscroll-contain max-h-[480px] {size ===
  'standard'
    ? 'w-52'
    : ''}"
  style="scrollbar-width: none"
>
  <slot />
</div>
